export default {
      id: "logo-small-usage",
      viewBox: "0 0 236 236",
      url: __webpack_public_path__ + "icons.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }